module.exports = __webpack_public_path__ + "img/certified.6625fcda.svg";